import { FC, useState } from 'react';
import { Tabs } from 'antd';

import { useAppSelector, useTranslate } from 'hooks';

import { TaxStatements } from './TaxStatements';
import { RejectedMessage } from 'componets/ui';
import { Transactions } from './Transactions';
import { AccountSummary } from './AccountSummary';

import { RequestStatus } from 'utils/constants';

import s from './index.module.scss';
import './index.scss';

export const Statement: FC = () => {
	const status = useAppSelector((state) => state.statement.status);

	const { accountSummaryText, transactionsText, taxStatementsText } = useTranslate([
		'accountSummaryText',
		'transactionsText',
		'taxStatementsText',
	]);
	const [type, setType] = useState('accountSummary');

	return (
		<>
			{status === RequestStatus.REJECTED ? (
				<RejectedMessage />
			) : (
				<div className={s.statement}>
					<Tabs
						className="accountTabs"
						type="card"
						defaultActiveKey={type}
						activeKey={type}
						onChange={(v: any) => setType(v)}
					>
						<Tabs.TabPane tab={accountSummaryText} key="accountSummary">
							<AccountSummary />
						</Tabs.TabPane>
						<Tabs.TabPane tab={transactionsText} key="transactions">
							<Transactions type={type} />
						</Tabs.TabPane>
						<Tabs.TabPane tab={taxStatementsText} key="taxStatements">
							<TaxStatements isActive={type === 'taxStatements'} />
						</Tabs.TabPane>
					</Tabs>
				</div>
			)}
		</>
	);
};
